import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, ArrowUpRight, Tractor, Coins, Globe2, Cpu, Leaf, MountainSnow, LineChart, Target, Sprout } from "lucide-react";

const ICONS = { Tractor, Coins, Globe2, Cpu, Leaf, MountainSnow, LineChart, Target, Sprout };

export default function Servizi() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="page-servizi">
      <section className="pt-24 md:pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#007A3D]">Servizi</span>
          <h1 className="mt-5 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-[#1A1A1A] max-w-4xl">Consulenza completa per ogni fase di crescita della tua impresa agricola.</h1>
          <p className="mt-6 text-lg text-[#6B7280] max-w-3xl leading-relaxed">Strategia, finanziamenti, innovazione, sostenibilità e sviluppo rurale. Un team unico per accompagnare l’impresa agricola sarda in ogni passaggio chiave.</p>
        </div>
      </section>
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((s) => {
            const Icon = ICONS[s.icon] || Sprout;
            return (
              <Link key={s.slug} to={`/servizi/${s.slug}`} data-testid={`servizi-card-${s.slug}`}
                className="group bg-white rounded-3xl p-7 border border-[#E5E7EB] hover-lift flex flex-col">
                <div className="w-12 h-12 rounded-2xl bg-[#EAF8F0] flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-[#007A3D]" />
                </div>
                <h3 className="font-display font-bold text-xl tracking-tight text-[#1A1A1A]">{s.name}</h3>
                <p className="mt-3 text-[#6B7280] text-sm leading-relaxed flex-1">{s.short}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#007A3D] group-hover:text-[#00A651]">Scopri <ArrowUpRight className="w-4 h-4" /></span>
              </Link>
            );
          })}
        </div>
      </section>
      <section className="py-20 md:py-28 bg-[#EAF8F0]">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="font-display font-black tracking-tighter text-3xl md:text-5xl text-[#1A1A1A]">Hai un progetto in mente?</h2>
          <p className="mt-5 text-lg text-[#374151]">Confrontiamoci. Una consulenza iniziale ci permette di mettere a fuoco priorità e leve.</p>
          <Link to="/contatti" className="mt-8 inline-flex items-center gap-2 bg-[#00A651] hover:bg-[#007A3D] text-white rounded-full px-7 py-4 font-medium" data-testid="servizi-cta">
            Richiedi una consulenza <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
